import { allApiWithHeaderToken } from '../api/api';
import { API_CONSTANTS } from '../constants/apiurl';

const VAPID_PUBLIC_KEY = 'BD7MFTEQjT-qsUgPta3Fj2PLr1qSOby8OVx1bSPG2i5nvqSoKlAGBGszZxIyerMP4r5GMqMWwNR14Hhkc_VLqDU';

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)));
}

export async function registerPushNotifications(userId) {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return;

  try {
    // Register service worker
    const reg = await navigator.serviceWorker.register('/sw.js');

    // Request permission
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') return;

    // Subscribe to push
    const subscription = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
    });

    const sub = subscription.toJSON();

    // Save to backend
    await allApiWithHeaderToken(
      API_CONSTANTS.SAVE_PUSH_SUBSCRIPTION,
      {
        user_id: userId,
        endpoint: sub.endpoint,
        keys: sub.keys,
      },
      'post'
    );
  } catch (err) {
    // Permission denied or unsupported — fail silently
    console.debug('Push notification setup skipped:', err.message);
  }
}
